import React from "react";
import styled from "styled-components";
import {NullableString} from "../../../types/nullable-types";
import {observer} from "mobx-react";

const ErrorMessageBox = styled.div`
    font-size: ${props => props.theme.fontSize.small};
    font-weight: ${props => props.theme.fontWeight.bold};
    margin: 0 4px 0 0;
    color: ${props => props.theme.colors.danger}
}   
`

interface InputFieldErrorMessageComponentProps {
    errorMessage?: NullableString;
}
export const InputFieldErrorMessageComponent: React.FC<InputFieldErrorMessageComponentProps> = observer((props) => {
    if(!props.errorMessage) {
        return null;
    }

    return (
        <ErrorMessageBox>
            {props.errorMessage}
        </ErrorMessageBox>
    );
});
